// Product description expand/collapse functionality
(function() {
  console.log('[Product Description] Script loaded');

  function initDescriptionToggle() {
    const descriptionWrapper = document.querySelector('.product__description-wrapper');
    const description = document.querySelector('.product__description');

    if (!description) {
      console.log('[Product Description] No description found');
      return;
    }

    console.log('[Product Description] Description found, setting up toggle');

    // Make the description clickable
    description.style.cursor = 'pointer';

    // Track expanded state
    let isExpanded = false;

    // Create and add the expand indicator
    const indicator = document.createElement('div');
    indicator.className = 'description-expand-indicator';
    indicator.innerHTML = '▼ Click to see full description';
    indicator.style.cssText = `
      font-size: 11px;
      color: #888;
      margin-top: 8px;
      text-align: center;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      cursor: pointer;
      transition: color 0.2s ease;
    `;

    if (descriptionWrapper) {
      descriptionWrapper.appendChild(indicator);
    } else {
      description.parentNode.insertBefore(indicator, description.nextSibling);
    }

    // Toggle function
    function toggleDescription() {
      isExpanded = !isExpanded;

      if (isExpanded) {
        description.classList.add('expanded');
        indicator.innerHTML = '▲ Click to collapse';
        indicator.style.color = '#444';
      } else {
        description.classList.remove('expanded');
        indicator.innerHTML = '▼ Click to see full description';
        indicator.style.color = '#888';
      }

      console.log('[Product Description] Toggled to:', isExpanded ? 'expanded' : 'collapsed');
    }

    // Add click listeners
    description.addEventListener('click', toggleDescription);
    indicator.addEventListener('click', toggleDescription);

    // Hover effects
    description.addEventListener('mouseenter', function() {
      if (!isExpanded) {
        indicator.style.color = '#444';
      }
    });

    description.addEventListener('mouseleave', function() {
      if (!isExpanded) {
        indicator.style.color = '#888';
      }
    });

    indicator.addEventListener('mouseenter', function() {
      indicator.style.color = '#0a0a0a';
    });

    indicator.addEventListener('mouseleave', function() {
      indicator.style.color = isExpanded ? '#444' : '#888';
    });

    console.log('[Product Description] Toggle initialized successfully');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initDescriptionToggle, 500));
  } else {
    setTimeout(initDescriptionToggle, 500);
  }
})();
